import React, { useEffect, useState } from "react";
import { useMLForm } from "../../../common/provider/form/Form.provider";
import {
  FormInstance,
  GetProp,
  Select,
  TimePicker,
  Upload,
  UploadProps,
} from "antd";
import { SimpleInput } from "../../../common/components/simpleInput";
import classes from "./formadd.module.scss";
import { Button } from "antd";
import FieldInterlocuteur from "./FieldInterlocuteur/FieldInterlocuteur";
import FieldEmail from "./FieldEmail/FieldEmail";
import FieldPhone from "./FieldPhone/FieldInterlocuteur";
// import { SimpleUploadFile } from '../../../common/simpleUploadFile/SimpleUploadFile';
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import { postMedia } from "../core/_request";
import { toast } from "sonner";
import { AiFillCamera } from "react-icons/ai";
import { Colors } from "../../../utilities/colors";
import { useQueryCustomerCategory } from "../core/_hooks";
import { API_BASE_URL_IMAGE } from "../../../utilities/API_CONSTANT";
import { CustomButton } from "../../../common/components/CustomButton/CustomButton";
import { useNavigate } from "react-router";

const FormAdd = ({ isSubmitting }: { isSubmitting: boolean }) => {
  const { RangePicker } = TimePicker;

  const { Form, form, initialValues } = useMLForm();
  const { setFieldValue, getFieldValue } = form as FormInstance;
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const { data: customerCategory, isLoading: isLoadingCustomerCategory } =
    useQueryCustomerCategory();

  const fillCustomerCategoryField = () => {
    const customerCategoryValue = getFieldValue("customerCategory");
    const customerCategoryfilledValue = customerCategoryValue?.["@id"];
    return setFieldValue("customerCategory", customerCategoryfilledValue);
  };

  useEffect(() => {
    fillCustomerCategoryField();
  }, [initialValues as any]);

  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const uploadButton = (
    <button style={{ border: 0, background: "none" }} type="button">
      {loading ? (
        <LoadingOutlined />
      ) : (
        <AiFillCamera size={32} color={Colors.white} />
      )}
    </button>
  );

  type FileType = Parameters<GetProp<UploadProps, "beforeUpload">>[0];
  const beforeUpload = (file: FileType) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      toast.error("You can only upload JPG/PNG file!");
    }

    const isLt1M = file.size / 1024 / 1024 < 1;
    if (!isLt1M) {
      toast.error("Image must smaller than 2MB!");
    }
    return isJpgOrPng && isLt1M;
  };

  var bodyFormData = new FormData();

  useEffect(() => {
    if ((initialValues as any)?.image) {
      const detail: any = (initialValues as any)?.image;
      console.log("initialValues image fff", detail?.["contentUrl"]);

      setImageUrl(
        detail?.["contentUrl"]
          ? `${API_BASE_URL_IMAGE}${detail?.["contentUrl"]}`
          : null
      );
    }
  }, [initialValues as any]);
  console.log("initialValues", initialValues);

  return (
    <div style={{ position: "relative", top: "-52px" }}>
      <div className="px-3">
        <SimpleInput
          Form={Form}
          name="image"
          customInput={
            <Upload
              name="image"
              listType="picture-circle"
              className="avatar-uploader"
              showUploadList={false}
              beforeUpload={() => false}
              onChange={(info) => {
                console.log("info", info);
                if (info.file) {
                  setImageUrl(URL.createObjectURL(info.file as any));
                }
                bodyFormData.append("file", info.file as any);
                console.log("info", info.file.size);

                postMedia(bodyFormData).then((res) => {
                  console.log("res", res);

                  setFieldValue("image", res?.["@id"]); //? res?.["@id"] :null);
                });
              }}
            >
              {imageUrl ? (
                <img
                  src={imageUrl}
                  alt="avatar"
                  style={{
                    width: "100%",
                    borderRadius: "50%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              ) : (
                uploadButton
              )}
            </Upload>
          }
        />
      </div>
      <div className="px-3 py-3">
        <div>
          <h6>Informations client</h6>
          <div className={classes["d-grid"] + " " + classes["grid-3"]}>
            <div>
              <SimpleInput
                Form={Form}
                name={"reference"}
                label={"Référence"}
                placeholder={"Référence"}
                rules={[
                  {
                    required: true,
                    message: "Le champ référence est requis.",
                  },
                ]}
              />
            </div>
            <div>
              <SimpleInput
                Form={Form}
                name={"name"}
                label={"Nom de la société"}
                placeholder={"Nom de la société"}
                rules={[
                  {
                    required: true,
                    message: "Le champ nom de la société est requis.",
                  },
                ]}
              />
            </div>
            <div>
              <SimpleInput
                Form={Form}
                name={"address"}
                label={"Adresse"}
                placeholder={"Adresse"}
              />
            </div>
            <div>
              <SimpleInput
                Form={Form}
                name={"customerCategory"}
                label={"Catégorie du client"}
                customInput={
                  <Select
                    placeholder={"Catégorie du client"}
                    loading={isLoadingCustomerCategory}
                    options={customerCategory}
                  />
                }
                rules={[
                  {
                    required: true,
                    message: "Le champ catégorie du client est requis.",
                  },
                ]}
              />
            </div>
            <div>
              <SimpleInput
                Form={Form}
                name={"schedule"}
                label={"Horaire"}
                customInput={
                  <RangePicker
                    placeholder={["Début", "Fin"]}
                    format={"HH:mm"}
                    needConfirm={false}
                    allowClear={false}
                  />
                }
              />
            </div>
          </div>
          <div className={"w-100"}>
            <FieldInterlocuteur />
          </div>
          <div className={"w-100"}>
            <FieldEmail />
          </div>
          <div className={"w-100"}>
            <FieldPhone />
          </div>
        </div>
        <div className="my-3">
          <h6>Admnistrative</h6>
          <div className={classes["d-grid"] + " " + classes["grid-2"]}>
            <div>
              <SimpleInput
                Form={Form}
                name={"nif"}
                label={"NIF"}
                placeholder={"NIF"}
              />
            </div>
            <div>
              <SimpleInput
                Form={Form}
                name={"stat"}
                label={"Stat"}
                placeholder={"Stat"}
              />
            </div>
          </div>
        </div>
        <div className="w-full d-flex justify-content-end gap-4">
          <CustomButton
            type="button"
            variant="secondary"
            onClick={() => navigate(-1)}
          >
            Retour
          </CustomButton>
          <CustomButton
            variant="primary"
            type="submit"
            isLoading={isSubmitting}
          >
            Enregistrer
          </CustomButton>
        </div>
        {/* <Button type="primary" shape="round" size={"large"} htmlType="submit">
          Enregistrer
        </Button> */}
      </div>
    </div>
  );
};

export default FormAdd;
